const expozoare = [
    {
        produs: 'ro',
        subTip: '',
        Cod: '1A',
        Tip: 'ROLETA CU CASETA STANDARD',
        Componente: 'ALB',
        Material: 'CARINA',
        Cote: '600x1200mm',
        Pret: '103,68 lei',
        imagine: '/images/expozoare/1A.jpg',
        precompletare:{
            'tipSubprodus':2,
            'culoareLamela':14,
            'material':1,
            'ax':'MIC',
            'culoareComponente':'ALB',
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'CASETA STANDARD',
            'denumireCuloareLamela':'ALB',
            'denumireMaterial':'CARINA', 
            } 
    },
    {
        produs: 'ro',
        subTip: '',
        Cod: '2A',
        Tip: 'ROLETA CU CASETA AVANGARD',
        Componente: 'STEJAR',
        Material: 'STYLE',
        Cote: '600x1200mm',
        Pret: '198,72 lei',
        imagine: '/images/expozoare/2A.jpg',
        precompletare:{
            'tipSubprodus':3,
            'culoareLamela':17,
            'material':14,
            'ax':'MIC',
            'culoareComponente':'STEJAR',
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'CASETA AVANGARD',
            'denumireCuloareLamela':'STEJAR',
            'denumireMaterial':'STYLE', 
            } 
    },
    {
        produs: 'ro',
        subTip: '',
        Cod: '3A',
        Tip: 'ROLETA VELUX',
        Componente: 'ALB/MARO',
        Material: 'STELLA COLOR',
        Cote: '600x1200mm',
        Pret: '213,84 lei',
        imagine: '/images/expozoare/3A.jpg',
        precompletare:{
            'tipSubprodus':8,
            'culoareLamela':14,
            'material':34,
            'ax':'MIC',
            'culoareComponente':'ALB',
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'CASETA VELUX',
            'denumireCuloareLamela':'ALB',
            'denumireMaterial':'STELLA COLOR', 
            } 
    },
    {
        produs: 'ro',
        subTip: '',
        Cod: '4A',
        Tip: 'ROLETA CU CASETA PREMIUM CU ARC',
        Componente: 'MARO',
        Material: 'IMPRIMAT',
        Cote: '600x1200mm',
        Pret: '276,48 lei',
        imagine: '/images/expozoare/4A.jpg',
        precompletare:{
            'tipSubprodus':7,
            'culoareLamela':15,
            'material':41,
            'ax':'MIC',
            'culoareComponente':'MARO',
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'CASETA PREMIUM CU ARC',
            'denumireCuloareLamela':'MARO',
            'denumireMaterial':'IMPRIMAT', 
            } 
    },
    {
        produs: 'ro',
        subTip: '',
        Cod: '5A',
        Tip: 'ROLETA CU CASETA STANDARD',
        Componente: 'ARGINTIU',
        Material: 'DAY NIGHT EXCLUSIV',
        Cote: '600x1200mm',
        Pret: '217,72 lei',
        imagine: '/images/expozoare/5A.jpg',
        precompletare:{
            'tipSubprodus':5,
            'culoareLamela':21,
            'material':19,
            'ax':'MIC',
            'culoareComponente':'ARGINTIU',
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'DAY&NIGHT CAS. STANDARD',
            'denumireCuloareLamela':'ARGINTIU',
            'denumireMaterial':'DAY NIGHT EXCLUSIV', 
            } 
    },
    {
        produs: 'ro',
        subTip: '',
        Cod: '6A',
        Tip: 'ROLETA CU CASETA PREMIUM CU LANT',
        Componente: 'ANTRACIT',
        Material: 'DAY NIGHT BLACKOUT',
        Cote: '600x1200mm',
        Pret: '298,08 lei',
        imagine: '/images/expozoare/6A.jpg',
        precompletare:{
            'tipSubprodus':9,
            'culoareLamela':16,
            'material':42,
            'ax':'MIC',
            'culoareComponente':'ANTRACIT',
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'CASETA PREMIUM CU LANT',
            'denumireCuloareLamela':'ANTRACIT',
            'denumireMaterial':'DAY NIGHT BLACKOUT', 
            } 
    },
    {
        produs: 'ro',
        subTip: '',
        Cod: '7A',
        Tip: 'ROLETA SIMPLA AX MIC 17MM',
        Componente: 'MARO',
        Material: 'STYLE',
        Cote: '600x1200mm',
        Pret: '116,64 lei',
        imagine: '/images/expozoare/7A.jpg',
        precompletare:{
            'tipSubprodus':1,
            'culoareLamela':15,
            'material':14,
            'ax':'MIC',
            'culoareComponente':'MARO',
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'ROLETA SIMPLA',
            'denumireCuloareLamela':'MARO',
            'denumireMaterial':'STYLE', 
            } 

    },
    {
        produs: 'ro',
        subTip: '',
        Cod: '8A',
        Tip: 'ROLETA SIMPLA AX MIC 17MM',
        Componente: 'ANTRACIT',
        Material: 'STELLA REFLEXIV',
        Cote: '600x1200mm',
        Pret: '104,32 lei',
        imagine: '/images/expozoare/8A.jpg',
        precompletare:{
            'tipSubprodus':1,
            'culoareLamela':16,
            'material':35,
            'ax':'MIC',
            'culoareComponente':'ANTRACIT',
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'ROLETA SIMPLA',
            'denumireCuloareLamela':'ANTRACIT',
            'denumireMaterial':'STELLA REFLEXIV', 
            } 

    },
    {
        produs: 'ro',
        subTip: '',
        Cod: '9A',
        Tip: 'ROLETA SIMPLA AX MIC 17MM',
        Componente: 'ALB',
        Material: 'CARINA',
        Cote: '600x1200mm',
        Pret: '56,16 lei',
        imagine: '/images/expozoare/9A.jpg',
        precompletare:{
            'tipSubprodus':1,
            'culoareLamela':14,
            'material':1,
            'ax':'MIC',
            'culoareComponente':'ALB',
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'ROLETA SIMPLA',
            'denumireCuloareLamela':'ALB',
            'denumireMaterial':'CARINA', 
            } 
    },
    {
        produs: 'ro',
        subTip: '',
        Cod: '10A',
        Tip: 'ROLETA SIMPLA AX MARE 25MM',
        Componente: 'ANTRACIT',
        Material: 'SCREEN',
        Cote: '600x1200mm',
        Pret: '122,47 lei',
        imagine: '/images/expozoare/10A.jpg',
        precompletare:{
            'tipSubprodus':1,
            'culoareLamela':16,
            'material':36,
            'ax':'MARE',
            'culoareComponente':'ANTRACIT',
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'ROLETA SIMPLA',
            'denumireCuloareLamela':'ANTRACIT',
            'denumireMaterial':'SCREEN', 
            } 
    },
    {
        produs: 'ro',
        subTip: '',
        Cod: '11A',
        Tip: 'ROLETA SIMPLA AX MARE/SUPORT+CASETA-PRINDERE IN TAVAN',
        Componente: 'MARO',
        Material: 'DAY NIGHT NATUR',
        Cote: '600x1200mm',
        Pret: '138,64 lei',
        imagine: '/images/expozoare/11A.jpg',
        precompletare:{
            'tipSubprodus':4,
            'culoareLamela':15,
            'material':13,
            'ax':'MARE',
            'culoareComponente':'MARO',
            'optional1':47,
            'buc':1,
            'tipProdus':'ro',
            'denumireProdus':'ROLETE TEXTILE',
            'denumireSubProdus':'DAY&NIGHT SIMPLU',
            'denumireCuloareLamela':'MARO',
            'denumireMaterial':'DAY NIGHT NATUR', 
            'denumireOptional1':'PROFIL CASETA AX 25mm TAVAN',
            } 
    },
    {
        produs: 'jv',
        subTip: 'JVP',
        Cod: '12A',
        Tip: 'JALUZEA TIP PERDEA 127mm',
        Material: 'M1001BO-1/M1001BO-8',
        Cote: '2000x2500mm',
        Pret: '1750,00 lei',
        imagine: '/images/expozoare/12A.jpg',
        precompletare:{
            'tipSubprodus':3,
            'material':56, 
            'denumireProdus':'JALUZELE TIP PERDEA',
            'denumireSubProdus':'Jaluzele tip Perdea 127',
            'denumireMaterial':'M1001BO',
        }
    },
    {
        produs: 'jv',
        subTip: 'JVP',
        Cod: '12B',
        Tip: 'JALUZEA TIP PERDEA 89mm',
        Material: 'M1001BO-1/M1001BO-8',
        Cote: '2000x2500mm',
        Pret: '1400,00 lei',
        imagine: '/images/expozoare/12B.jpg',
        precompletare:{
            'tipSubprodus':4,
            'material':56, 
            'denumireProdus':'JALUZELE TIP PERDEA',
            'denumireSubProdus':'Jaluzele tip Perdea 89',
            'denumireMaterial':'M1001BO/',
        }
    },

    {
        produs: 'jv',
        subTip: 'JVV',
        Cod: '14A',
        Tip: 'JALUZEA VERTICALA INCLINATA',
        Material: 'CAROL',
        Cote: '1000X370mm',
        Pret: '121,50 lei',
        imagine: '/images/expozoare/14A.jpg',
        precompletare:{
            'tipSubprodus':1,
            // 'material':10, 
            'optional2':9,
            // 'denumireProdus':'JALUZELE VERTICALE',
            // 'denumireSubProdus':'Jaluzele verticale 127',
            // 'denumireMaterial':'CAROL',
            'denumireOptional2':'Inclinata',
        }
    },
    {
        produs: 'jv',
        subTip: 'JVI',
        Cod: '15A',
        Tip: 'JALUZEA TIP IDILIA',
        Cote: '2000X2500mm',
        Pret: '1380,00 lei',
        imagine: '/images/expozoare/15A.jpg',
        precompletare:{
            'tipSubprodus':5,
            'material':26, 
            'denumireProdus':'JALUZELE TIP IDILIA',
            'denumireSubProdus':'Idilia',
            'denumireMaterial':'IDILIA',
        }
    },
    {
        produs: 'jp',
        Cod: '16A',
        Tip: 'JALUZELE PLISATE',
        Componente: 'ALB/MARO',
        Material: 'TUISS',
        'Grad de transparenta': 'OPAC',
        Cote: '600X1200mm',
        Pret: '216,00 lei',
        imagine: '/images/expozoare/16A.jpg',
        precompletare:{}
    },
    {
        produs: 'jp',
        Cod: '17A',
        Tip: 'JALUZELE PLISATE',
        Componente: 'ALB/MARO',
        Material: 'ORVI',
        'Grad de transparenta': 'SEMI-OPAC',
        Cote: '500X1400mm',
        Pret: '154,00 lei',
        imagine: '/images/expozoare/17A.jpg',
        precompletare:{}
    },

    {
        produs: 'pi',
        Cod: '18A',
        Tip: 'PLASA RULOU TIP FEREASTRA',
        Componente: 'ALB',
        Cote: '500x1200mm',
        'Pret*)': '297,84 lei',
        imagine: '/images/expozoare/18A.jpg',  
        precompletare:{
            'tipSubprodus':5,
            'culoareCaseta':2,
            'buc':1,
            'tipProdus':'pi',
            'denumireProdus':'PLASE ANTI-INSECTE',
            'denumireSubProdus':'PLISSE TIP GEAM',
            'denumireCuloareCaseta':'ALB',
            }     
    },
    {
        produs: 'pi',
        Cod: '19A',
        Tip: 'PLASA PLISSE TIP USA',
        Componente: 'ANTRACIT',
        Cote: '1000x2000mm',
        'Pret*)': '783,73 lei',
        imagine: '/images/expozoare/19A.jpg',  
        precompletare:{
            'tipSubprodus':6,
            'culoareCaseta':10,
            'buc':1,
            'tipProdus':'pi',
            'denumireProdus':'PLASE ANTI-INSECTE',
            'denumireSubProdus':'PLISSE TIP USA',
            'denumireCuloareCaseta':'ANTRACIT 7016',
            }  
    }
  

];

export default expozoare;